import { Component, OnInit } from '@angular/core';
import { Meta } from'@angular/platform-browser';
import { Offerte } from '../model/offerte';
import { OfferteServiceService } from '../service/offerte-service.service';


@Component({
  selector: 'app-chisiamo',
  templateUrl: './chisiamo.component.html',
  styleUrls: ['./chisiamo.component.scss']
})
export class ChisiamoComponent implements OnInit {
  lstOffertePunta: Array<Offerte>;
  constructor(private service: OfferteServiceService,private meta: Meta) 
  { 
    // this.lstOffertePunta = this.service.getOffertePunta();
    this.lstOffertePunta=null;
    this.service.getOffertePunta().subscribe(data => this.lstOffertePunta=data);
    
    this.meta.updateTag({ name:'description', content:'Chi siamo|Ti aiutiamo a risparmiare su Energia Elettrica e Gas.'});
    this.meta.addTag({ name: 'keywords', content: 'fornituralternativa, fornitura elettrica, fornitura Gas, Risparmio' });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/chisiamo/chisiamo.component.ts